export enum CampusSurveyAnswerTypes {
  GET_CAMPUSSURVEYANSWER_LOADING = 'GET_CAMPUSSURVEYANSWER_LOADING',
  GET_CAMPUSSURVEYANSWER_SUCCESS = 'GET_CAMPUSSURVEYANSWER_SUCCESS',
  GET_CAMPUSSURVEYANSWER_FAILURE = 'GET_CAMPUSSURVEYANSWER_FAILURE',
  GET_CAMPUSSURVEYANSWERREPORT_LOADING = 'GET_CAMPUSSURVEYANSWERREPORT_LOADING',
  GET_CAMPUSSURVEYANSWERREPORT_SUCCESS = 'GET_CAMPUSSURVEYANSWERREPORT_SUCCESS',
  GET_CAMPUSSURVEYANSWERREPORT_FAILURE = 'GET_CAMPUSSURVEYANSWERREPORT_FAILURE',
}
